import { createAction } from '@reduxjs/toolkit';

const ACTION_PREFIX = 'profile';

export const profileDetailsFetch = createAction(`${ACTION_PREFIX}/FETCH_PROFILE_DETAILS`);
export const profileDetailsFetchSucceeded = createAction(`${ACTION_PREFIX}/FETCH_PROFILE_DETAILS_SUCCEEDED`);
export const profileDetailsFetchFailed = createAction(`${ACTION_PREFIX}/FETCH_PROFILE_DETAILS_FAILED`);

export const changeProfileDetails = createAction(`${ACTION_PREFIX}/CHANGE_PROFILE_DETAILS`);
export const changeProfileDetailsSucceeded = createAction(`${ACTION_PREFIX}/CHANGE_PROFILE_DETAILS_SUCCEEDED`);
export const changeProfileDetailsFailed = createAction(`${ACTION_PREFIX}/CHANGE_PROFILE_DETAILS_FAILED`);

export const setPassword = createAction(`${ACTION_PREFIX}/SET_PASSWORD`);
export const setPasswordSucceeded = createAction(`${ACTION_PREFIX}/SET_PASSWORD_SUCCEEDED`);
export const setPasswordFailed = createAction(`${ACTION_PREFIX}/SET_PASSWORD_FAILED`);

export const changePassword = createAction(`${ACTION_PREFIX}/CHANGE_PASSWORD`);
export const changePasswordSucceeded = createAction(`${ACTION_PREFIX}/CHANGE_PASSWORD_SUCCEEDED`);
export const changePasswordFailed = createAction(`${ACTION_PREFIX}/CHANGE_PASSWORD_FAILED`);

export const checkIsInvited = createAction(`${ACTION_PREFIX}/IS_INVITED`);
export const checkIsInvitedSucceeded = createAction(`${ACTION_PREFIX}/IS_INVITED_SUCCEEDED`);
export const checkIsInvitedFailed = createAction(`${ACTION_PREFIX}/IS_INVITED_FAILED`);

export const moveAccount = createAction(`${ACTION_PREFIX}/MOVE_ACCOUNT`);
export const moveAccountSucceeded = createAction(`${ACTION_PREFIX}/MOVE_ACCOUNT_SUCCEEDED`);
export const moveAccountFailed = createAction(`${ACTION_PREFIX}/MOVE_ACCOUNT_FAILED`);

export const rejectInvite = createAction(`${ACTION_PREFIX}/REJECT_INVITE`);
export const rejectInviteSucceeded = createAction(`${ACTION_PREFIX}/REJECT_INVITE_SUCCEEDED`);
export const rejectInviteFailed = createAction(`${ACTION_PREFIX}/REJECT_INVITE_FAILED`);

export const ProfileActions = {
  rejectInvite,
  rejectInviteSucceeded,
  rejectInviteFailed,

  profileDetailsFetch,
  profileDetailsFetchSucceeded,
  profileDetailsFetchFailed,

  changeProfileDetails,
  changeProfileDetailsSucceeded,
  changeProfileDetailsFailed,

  changePassword,
  changePasswordSucceeded,
  changePasswordFailed,

  setPassword,
  setPasswordSucceeded,
  setPasswordFailed,

  checkIsInvited,
  checkIsInvitedSucceeded,
  checkIsInvitedFailed,

  moveAccount,
  moveAccountSucceeded,
  moveAccountFailed,
};
